import { render } from "./SingleJob.vue?vue&type=template&id=fcd61d8c"
import script from "./SingleJob.vue?vue&type=script&lang=js"
export * from "./SingleJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__